module.exports = __webpack_public_path__ + "img/HZ-G1358.93271553.jpg";